import React, { useMemo } from 'react';
import {
	PATHOLOGY_BUTTON_OPTIONS,
	PathologyOption,
} from '../../Helpers/pathology/pathologyButtonOptions';
import ToggleButtons from '../../../../Components/ToggleButtons/ToggleButtons';
import { ToggleButtonView } from '../../../../Enums/ToggleButtonView.enum';
import { PathologyItem } from '../../Enums/PathologyItem.enum';
import DENTToothQuickPathologyModalDecayButtons from './DENTToothQuickPathologyModalDecayButtons';
import DENTModalOverviewPathologyFracture from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyFracture';
import DENTToothQuickPathologyModalToothWearButtons from './DENTToothQuickPathologyModalToothWearButtons';
import DENTModalOverviewPathologyDiscoloration from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyDiscoloration';
import DENTModalOverviewPathologyApical from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyApical';
import DENTModalOverviewPathologyDevelopmentDisorder from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyDevelopmentDisorder';
import Button from '../../../../Components/Button/Button';
import styles from './DENTToothQuickPathologyModal.module.scss';
import { useDENTContext } from '../../Services/DENTContext';
import DENTToothQuickAdjustmentModalTitle from '../DENTToothQuickAdjustmentModal/DENTToothQuickAdjustmentModalTitle';
import DENTModalOverviewPathologyRootDecay from '../DENTModalOverviewPathologyButtons/DENTModalOverviewPathologyRootDecay';

const DENTToothQuickPathologyModal = () => {
	const [selectedOption, setSelectedOption] = React.useState<PathologyOption>();
	const { handleUpdateTooth, activeTooth } = useDENTContext();

	const selectedActionButtons = useMemo(() => {
		switch (selectedOption?.value) {
			case PathologyItem.DECAY:
				return <DENTToothQuickPathologyModalDecayButtons />;
			case PathologyItem.FRACTURE:
				return <DENTModalOverviewPathologyFracture />;
			case PathologyItem.TOOTH_WEAR:
				return <DENTToothQuickPathologyModalToothWearButtons />;
			case PathologyItem.DISCOLORATION:
				return <DENTModalOverviewPathologyDiscoloration />;
			case PathologyItem.APICAL:
				return <DENTModalOverviewPathologyApical />;
			case PathologyItem.DEVELOPMENT_DISORDER:
				return <DENTModalOverviewPathologyDevelopmentDisorder />;
			case PathologyItem.ROOT_DECAY:
				return <DENTModalOverviewPathologyRootDecay />;
			default:
				return null;
		}
	}, [selectedOption]);

	const handleSubmit = async () => {
		if (!activeTooth?.pathology) return;
		handleUpdateTooth({
			pathology: activeTooth.pathology,
		});
	};

	return (
		<div className={styles.wrapper}>
			<DENTToothQuickAdjustmentModalTitle
				title={'patientTreatment.meddiDENT.dentalCross.overviewModal.pathology'}
			/>
			<ToggleButtons<PathologyOption>
				options={PATHOLOGY_BUTTON_OPTIONS}
				selectedOption={selectedOption}
				onChange={setSelectedOption}
				view={ToggleButtonView.HORIZONTAL_MULTILINE}
			/>
			{selectedActionButtons}
			<Button title={'base.shared.form.send'} onClick={handleSubmit} />
		</div>
	);
};

export default DENTToothQuickPathologyModal;
